import { MinimalDiscipline } from '../../pages/employees/types';
import { IfspContextDataType } from '../../pages/ifsp/ifspContextApi/IfspContex';
import { UploadToTBRPayloadType } from '../../pages/ifspNew/ifspComponents/IfspTBRCheckModal';
import { TBRPreRequisiteType } from '../../pages/ifspNew/IfspMainScreen';
import { IfspHeartBeatReqBodyType } from '../../pages/ifspNew/IfspNavBar/IfspTabNavigationComponent';
import { IfspReportCompletedByType } from '../../pages/ifspNew/IfspReportScreens/IfspReportMainScreen';
import { IfspClientDetailsType } from '../../redux/features/ifsp/ifspClientDetailsSlice';
import { IfspReportDailyRoutineType } from '../../redux/features/ifsp/ifspDailyRoutineSlice';
import { IfspReportDevelopmentalSummaryType } from '../../redux/features/ifsp/ifspDevelopmentSummarySlice';
import { IfspReportFamilyConcernType } from '../../redux/features/ifsp/ifspFamilyConcernSlice';
import { IfspHealthSummaryReportType } from '../../redux/features/ifsp/ifspHealthSummarySlice';
import { IfspHeartBeatType } from '../../redux/features/ifsp/ifspHeartBeatslice';
import { ChildAndFamilOutcomesType } from '../../redux/features/ifsp/ifspOutcomesSlice';
import { IfspSDPAndConsentType } from '../../redux/features/ifsp/ifspSDPAndConsentSlice';
import { IfspTransitionDataType } from '../../redux/features/ifsp/ifspTransitionSlice';
import { ApiResponseHandler } from '../ApiResponseHandler';
import { REFERRAL_PROGRAM_KEY, THOM_BASE_URL } from '../Constant';
import ThomApiClient from '../ThomApiClient';

export interface EmployeeListType {
  id: string;
  name: string | null;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phone: string | null;
  disciplineType: string | null;
  disciplineHistoryList?: MinimalDiscipline[];
  roles: string[] | null;
  isInActive?: boolean;
}

export const getAllEmployeeMinimalList = async (
  employeeIds?: string[],
): Promise<EmployeeListType[]> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<EmployeeListType[]>(
      `employee/list?empIds=${employeeIds || []}`,
    ),
  );
};

export const getIfspById = async (id: string) => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<IfspContextDataType>(
      `ifsp?clientId=${id}&referralProgramId=${referralProgramId ?? ''}`,
    ),
  );
};

export const createIfsp = async (
  data: IfspContextDataType,
  clientId: string,
) => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().post(
      `ifsp?clientId=${clientId}&referralProgramId=${referralProgramId ?? ''}`,
      data,
    ),
  );
};

export const downloadIfsp = async (
  clientId: string,
  localTimezone: string,
): Promise<Blob> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<Blob>(
      `ifsp/download?clientId=${clientId}&timezone=${localTimezone}&referralProgramId=${
        referralProgramId ?? ''
      }`,
      {},
      {
        baseURL: THOM_BASE_URL,
        responseType: 'blob',
      },
    ),
  );
};

export const initiateIfsp = async (clientId: string) => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().post(
      `ifsp/initiate?clientId=${clientId}&referralProgramId=${
        referralProgramId ?? ''
      }`,
      {},
    ),
  );
};

export const getIfsp = async (
  clientId: string,
): Promise<IfspClientDetailsType> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<IfspClientDetailsType>(
      `/ifsp/client?clientId=${clientId}&referralProgramId=${
        referralProgramId ?? ''
      }`,
    ),
  );
};

export const deleteIfspMembers = async (memberId: string) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete(`/ifsp/team-member/${memberId}`),
  );
};

export const getIfspDailyRoutineReport =
  async (): Promise<IfspReportDailyRoutineType> => {
    return ApiResponseHandler(
      await ThomApiClient.getInstance().get(`/ifsp/report/daily-routines`),
    );
  };

export const addOrUpdateIfspDailyRoutineReport = async (
  data: IfspReportDailyRoutineType,
) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().put(`/ifsp/report/daily-routines`, data),
  );
};

export const getIfspDevelopmentSummaryReport =
  async (): Promise<IfspReportDevelopmentalSummaryType> => {
    return ApiResponseHandler(
      await ThomApiClient.getInstance().get(
        `/ifsp/report/developmental-summary`,
      ),
    );
  };

export const addOrUpdateIfspDevelopmentSummaryReport = async (
  data: IfspReportDevelopmentalSummaryType,
) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().put(
      `/ifsp/report/developmental-summary`,
      data,
    ),
  );
};

export const getIfspFamilyConcernReport =
  async (): Promise<IfspReportFamilyConcernType> => {
    return ApiResponseHandler(
      await ThomApiClient.getInstance().get(`/ifsp/report/family-concern`),
    );
  };

export const addOrUpdateIfspFamilyConcernReport = async (
  data: IfspReportFamilyConcernType,
) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().put(`/ifsp/report/family-concern`, data),
  );
};

export const getIfspHealthAndEligibilitySummaryReport =
  async (): Promise<IfspHealthSummaryReportType> => {
    return ApiResponseHandler(
      await ThomApiClient.getInstance().get(`/ifsp/report/health-eligibility`),
    );
  };

export const addOrUpdateIfspHealthAndEligibilitySummaryReport = async (
  data: IfspHealthSummaryReportType,
) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().put(
      `/ifsp/report/health-eligibility`,
      data,
    ),
  );
};

export const getIfspReportCompletedDetails =
  async (): Promise<IfspReportCompletedByType> => {
    return ApiResponseHandler(
      await ThomApiClient.getInstance().get('ifsp/report-completed'),
    );
  };

export const addOrUpdateIfspReportCompletedDetails = async (
  data: IfspReportCompletedByType,
) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().put('ifsp/report-completed', data),
  );
};

export const deleteDailyRoutineReport = async (dailyRoutineId: string) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete(
      `/ifsp/daily-routine/${dailyRoutineId}`,
    ),
  );
};

export const deleteIfspReportCustomRoutine = async (routineId: string) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete(
      `/ifsp/custom-routine/${routineId}`,
    ),
  );
};

export const deleteIfspFamilyConcern = async (familyConcernId: string) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete(
      `/ifsp/family-concern/${familyConcernId}`,
    ),
  );
};

export const deleteIfspHealthAndEligibilitySummary = async (
  summaryId: string,
) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete(
      `/ifsp/health-eligibility/${summaryId}`,
    ),
  );
};

export const deleteEvaluatonTeamMember = async (memberId: string) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete(
      `/ifsp/evaluation-team-member/${memberId}`,
    ),
  );
};

export const deleteIfspDevelopmentalSummary = async (summaryId: string) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete(
      `/ifsp/developmental-summary/${summaryId}`,
    ),
  );
};
export const getIfspOutcome = async (): Promise<ChildAndFamilOutcomesType> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<ChildAndFamilOutcomesType>(
      `/ifsp/outcome`,
    ),
  );
};

export const deleteIfspOutcome = async (outcomeId: string) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete(`/ifsp/outcome/${outcomeId}`),
  );
};

export const deleteOutcomeProgressInfo = async (progressInfoId: string) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete(
      `/ifsp/outcome-progress/${progressInfoId}`,
    ),
  );
};

export const getIfspServiceDeliveryPlanAndConsent =
  async (): Promise<IfspSDPAndConsentType> => {
    return ApiResponseHandler(
      await ThomApiClient.getInstance().get<IfspSDPAndConsentType>(
        `/ifsp/service-delivery`,
      ),
    );
  };

export const deleteServiceDeliveryPlan = async (serviceDeliveryId: string) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete(
      `/ifsp/service/${serviceDeliveryId}`,
    ),
  );
};

export const deleteIfspService = async (serviceId: string) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete(
      `/ifsp/service-delivery/${serviceId}`,
    ),
  );
};

export const getIfspTransition = async (): Promise<IfspTransitionDataType> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<IfspTransitionDataType>(
      `/ifsp/transition`,
    ),
  );
};

export const createMainIfsp = async (data: IfspClientDetailsType) => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().post(
      `/ifsp/client?referralProgramId=${referralProgramId ?? ''}`,
      data,
    ),
  );
};

export const updateIfsp = async (data: IfspClientDetailsType) => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().put(
      `/ifsp/client?referralProgramId=${referralProgramId ?? ''}`,
      data,
    ),
  );
};

export const addOrUpdateIfspOutcome = async (
  data: ChildAndFamilOutcomesType,
) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().put(`/ifsp/outcome`, data),
  );
};

export const addOrUpdateIfspServiceDeliveryPlanAndConsent = async (
  data: IfspSDPAndConsentType,
) => {
  const clientId = localStorage.getItem('ClientId');
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().put(
      `/ifsp/service-delivery?clientId=${clientId}&referralProgramId=${
        referralProgramId ?? ''
      }`,
      data,
    ),
  );
};

export const deleteIfspConsent = async (consentId: string) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete(`/ifsp/consent/${consentId}`),
  );
};

export const addOrUpdateTransition = async (data: IfspTransitionDataType) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().put(`/ifsp/transition`, data),
  );
};

export const ifspHeartBeat = async (
  pingData: IfspHeartBeatReqBodyType,
): Promise<IfspHeartBeatType> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().post(`/ifsp/heartbeat`, pingData),
  );
};

export const getTBRPreRequisite = async (): Promise<TBRPreRequisiteType> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<TBRPreRequisiteType>(
      `/ifsp/upload-to-tbr`,
    ),
  );
};

export const uploadIfspToTBR = async (data: UploadToTBRPayloadType) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().put(`/ifsp/upload-to-tbr`, data),
  );
};

export const downloadMainIfsp = async (
  clientId: string,
  localTimezone: string,
  language = 'en',
): Promise<Blob> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<Blob>(
      `/ifsp/new/download?clientId=${clientId}&timezone=${localTimezone}&referralProgramId=${
        referralProgramId ?? ''
      }&language=${language}`,
      {},
      {
        baseURL: THOM_BASE_URL,
        responseType: 'blob',
      },
    ),
  );
};

export const downloadIfspReport = async (
  clientId: string,
  localTimezone: string,
): Promise<Blob> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<Blob>(
      `/ifsp/report/download?clientId=${clientId}&timezone=${localTimezone}&referralProgramId=${
        referralProgramId ?? ''
      }`,
      {},
      {
        baseURL: THOM_BASE_URL,
        responseType: 'blob',
      },
    ),
  );
};

export const downloadIfspOutcomes = async (
  clientId: string,
  localTimezone: string,
): Promise<Blob> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<Blob>(
      `/ifsp/outcome/download?clientId=${clientId}&timezone=${localTimezone}&referralProgramId=${
        referralProgramId ?? ''
      }`,
      {},
      {
        baseURL: THOM_BASE_URL,
        responseType: 'blob',
      },
    ),
  );
};

export const downloadIfspSDPAndConsent = async (
  clientId: string,
  localTimezone: string,
): Promise<Blob> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<Blob>(
      `/ifsp/service/download?clientId=${clientId}&timezone=${localTimezone}&referralProgramId=${
        referralProgramId ?? ''
      }`,
      {},
      {
        baseURL: THOM_BASE_URL,
        responseType: 'blob',
      },
    ),
  );
};

export const downloadIfspTransition = async (
  clientId: string,
  localTimezone: string,
): Promise<Blob> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<Blob>(
      `/ifsp/transition/download?clientId=${clientId}&timezone=${localTimezone}&referralProgramId=${
        referralProgramId ?? ''
      }`,
      {},
      {
        baseURL: THOM_BASE_URL,
        responseType: 'blob',
      },
    ),
  );
};
